import { MapPin } from "lucide-react";
import stripeLogo from "@/assets/admin_dashboard/stripe_logo.png";

interface PaymentMethodSelectorProps {
  value: "stripe" | "manual";
  onChange: (method: "stripe" | "manual") => void;
  stripeAvailable: boolean;
}

const PaymentMethodSelector = ({ value, onChange, stripeAvailable }: PaymentMethodSelectorProps) => {
  if (!stripeAvailable) {
    // If Stripe is not available, show info only. No radio selection needed
    return (
      <div className="border rounded-xl overflow-hidden">
        <div className="flex items-center gap-3 px-4 py-3">
          <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center shrink-0">
            <MapPin className="h-4 w-4 text-muted-foreground" />
          </div>
          <div>
            <div className="text-sm font-medium">Pay at venue</div>
            <div className="text-xs text-muted-foreground">
              Pay directly at the venue on your visit
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {/* Pay Online option */}
      <button
        type="button"
        onClick={() => onChange("stripe")}
        className={`w-full flex items-center gap-3 px-4 py-3 border rounded-xl transition-colors ${
          value === "stripe" ? "bg-primary/5 border-primary" : "hover:bg-muted-foreground/5 border-border"
        }`}
      >
        <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
          value === "stripe" ? "border-primary" : "border-muted-foreground/30"
        }`}>
          {value === "stripe" && (
            <div className="w-2.5 h-2.5 rounded-full bg-primary" />
          )}
        </div>
        <div className="w-8 h-8 rounded-lg bg-[#635BFF]/10 flex items-center justify-center shrink-0">
          <img src={stripeLogo} alt="Stripe" className="w-10 h-auto object-contain" />
        </div>
        <div className="text-left">
          <div className="text-sm font-medium">Pay online (Stripe)</div>
          <div className="text-xs text-muted-foreground">
            Secure payment via credit or debit card
          </div>
        </div>
      </button>

      {/* Pay at Venue option */}
      <button
        type="button"
        onClick={() => onChange("manual")}
        className={`w-full flex items-center gap-3 px-4 py-3 border rounded-xl transition-colors ${
          value === "manual" ? "bg-primary/5 border-primary" : "hover:bg-muted-foreground/5 border-border"
        }`}
      >
        <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
          value === "manual" ? "border-primary" : "border-muted-foreground/30"
        }`}>
          {value === "manual" && (
            <div className="w-2.5 h-2.5 rounded-full bg-primary" />
          )}
        </div>
        <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center shrink-0">
          <MapPin className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="text-left">
          <div className="text-sm font-medium">Pay at venue</div>
          <div className="text-xs text-muted-foreground">
            Pay directly at the venue on your visit
          </div>
        </div>
      </button>
    </div>
  );
};

export default PaymentMethodSelector;
